// src/app/components/direct-debit-request-content/index.js

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ActionButton from 'SharedComponents/action-button';
import PopoverHover from 'SharedComponents/popover-hover';
import Tabs from 'SharedComponents/tabs';
import DirectDebitRequestServiceAgreementText from 'SharedComponents/direct-debit-request-service-agreement-text';

import styles from './index.css';

const DirectDebitRequestContentWrapper = styled.div`${styles}`;

const DirectDebitRequestContent = ({
  mode,
  acceptedRoundupsTerms,
  updatingAcceptedRoundUpTerms,
  updatingAccountDebitStatus,
  onAccept,
}) => {
  const [activeRoundUpTermsTab, setActiveRoundUpTermsTab] = useState(
    'dd-request',
  );

  const isSubmitMode = mode === 'submit';

  const onRoundUpTermsTabChanged = (newActiveTab) => {
    console.log(
      'DirectDebitRequestContent - onRoundUpTermsTabChanged triggered with newActiveTab: ',
      newActiveTab,
    );

    setActiveRoundUpTermsTab(newActiveTab);
  };

  const getActionButtonText = () => {
    if (!isSubmitMode) {
      return 'Direct Debit Request Accepted';
    }

    if (acceptedRoundupsTerms) {
      return 'Accepted';
    }

    if (updatingAcceptedRoundUpTerms) {
      return 'Submitting...';
    }

    return 'Submit Direct Debit Request and Enable Account';
  };

  const getAcceptanceText = () => {
    if (!isSubmitMode) {
      return 'Your Direct Debit Request has been accepted and is currently active.';
    }

    return 'By clicking the button below, you request and authorise Zai Australia Pty Ltd (Zai) to arrange a debit to your nominated account to pay for services provided by Boost Your Super as per the DDRSA.';
  };

  const isActionButtonDisabled = (
    !isSubmitMode
    || updatingAccountDebitStatus
    || updatingAcceptedRoundUpTerms
    || acceptedRoundupsTerms
  );

  const getInfoPopoverText = () => {
    if (!acceptedRoundupsTerms) {
      return 'You must submit a Direct Debit Request to Zai Australia Pty Ltd (Zai) in order to use this service.';
    }
    return 'Your Direct Debit Request has been accepted and allows us to transfer Round-Ups to your super. Should you wish to retract your authorisation, please email us at accounts@boostyoursuper.com.au and we will assist you.';
  };

  const handleAccept = () => {
    console.log(
      'DirectDebitRequestContent - handleAccept triggered',
    );

    if (!isSubmitMode) {
      console.log(
        'DirectDebitRequestContent - handleAccept ignored in view mode',
      );
      return;
    }

    if (!onAccept) {
      console.log(
        'DirectDebitRequestContent - handleAccept no onAccept function provided',
      );
      return;
    }

    onAccept();
  };

  const renderTabContent = () => {
    if (activeRoundUpTermsTab === 'dd-request') {
      return (
        <div>
          <h3>Direct Debit Request</h3>

          <p>
            In order to provide you with Round-Ups you will need to submit
            a Direct Debit Request to Zai Australia Pty Ltd that is subject
            to the terms and conditions of Zai&apos;s Direct Debit Request
            Service Agreement, which you can view using the View DDRSA tab.
          </p>

          <p>
            <b>Zai Australia Pty Ltd</b>
            {' '}
            handles the direct debit that withdraws the round-up amounts
            from your account so they can be transferred to your super
            account.
          </p>

          <p>
            This debit or charge will be arranged by Zai&apos;s financial
            institution and made through the Bulk Electronic Clearing
            System Framework (BECS) from your nominated account.
          </p>
        </div>
      );
    }

    if (activeRoundUpTermsTab === 'ddr-agreement') {
      return <DirectDebitRequestServiceAgreementText />;
    }

    return null;
  };

  return (
    <DirectDebitRequestContentWrapper>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '70vh',
          maxHeight: '700px',
          minHeight: '400px',
          width: '100%',
          minWidth: 0,
        }}
      >
        <div
          style={{
            flexShrink: 0,
            width: '100%',
            minWidth: 0,
          }}
        >
          <Tabs
            onActiveTabChanged={onRoundUpTermsTabChanged}
            activeTab={activeRoundUpTermsTab}
            tabs={[
              {
                label: 'DD Request',
                value: 'dd-request',
              },
              {
                label: 'View DDRSA',
                value: 'ddr-agreement',
              },
            ]}
          />
        </div>

        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: '15px 10px 20px',
          }}
        >
          {renderTabContent()}
        </div>

        <div
          style={{
            flexShrink: 0,
            position: 'sticky',
            bottom: 0,
            background: '#fff',
            borderTop: '1px solid #ddd',
            padding: '15px 10px',
            zIndex: 1,
          }}
        >
          <div className="accept-terms-info">
            <p
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                fontSize: 'smaller',
              }}
            >
              <span>{getAcceptanceText()}</span>

              <span className="pop-over-container">
                <PopoverHover
                  content={(
                    <div
                      style={{
                        maxWidth: '300px',
                        padding: 10,
                        fontSize: '16px',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        flexDirection: 'column',
                        textAlign: 'left',
                      }}
                    >
                      {getInfoPopoverText()}
                    </div>
                  )}
                  header={null}
                  img={null}
                  itemToPopover={(
                    <i
                      className="material-icons"
                      style={{
                        margin: '0 5px',
                        verticalAlign: '-40%',
                      }}
                    >
                      info
                    </i>
                  )}
                  anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                  }}
                />
              </span>
            </p>
          </div>

          <ActionButton
            style={{
              width: '100%',
              margin: '20px 0',
            }}
            text={getActionButtonText()}
            onClick={handleAccept}
            color="#fff"
            large
            disabled={isActionButtonDisabled}
          />
        </div>
      </div>
    </DirectDebitRequestContentWrapper>
  );
};

DirectDebitRequestContent.propTypes = {
  mode: PropTypes.oneOf(['submit', 'view']),
  acceptedRoundupsTerms: PropTypes.bool,
  updatingAcceptedRoundUpTerms: PropTypes.bool,
  updatingAccountDebitStatus: PropTypes.bool,
  onAccept: PropTypes.func,
};

DirectDebitRequestContent.defaultProps = {
  mode: 'view',
  acceptedRoundupsTerms: false,
  updatingAcceptedRoundUpTerms: false,
  updatingAccountDebitStatus: false,
  onAccept: undefined,
};

export default DirectDebitRequestContent;
